import * as React from 'react'
import { SVGProps } from 'react'

export const ChevronIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width='15' height='26' viewBox='0 0 15 26' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M2 2L13 13L2 24' stroke='currentColor' strokeWidth='4' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
)
